import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import Button from '../Button';
import { classNames } from '../../utils';
import styles from './NewFeaturePopup.module.css';
const NewFeaturePopup = ({ onDismiss, onAction, rootClassName, }) => {
    useEffect(() => {
        // auto dismiss after 7 seconds
        const autoDismiss = setTimeout(onDismiss, 7000);
        return () => {
            clearTimeout(autoDismiss);
        };
    }, []);
    return (_jsxs("div", Object.assign({ className: classNames(rootClassName, styles.root) }, { children: [_jsx("div", Object.assign({ className: styles.msg }, { children: "New Features have been added in the Platform" }), void 0), _jsx(Button, Object.assign({ variant: "text", onClick: () => {
                    onAction();
                    onDismiss();
                } }, { children: "Show" }), void 0)] }), void 0));
};
export default NewFeaturePopup;
